// src/components/call/CallFloatingUI.jsx
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { acceptCall, rejectCall, hangup, toggleMic, toggleCam } from '../../actions/call.actions';

export default function CallFloatingUI() {
    const dispatch = useDispatch();
    const { status, incoming, mode } = useSelector(s => s.call);
    const ref = useRef(null);

    useEffect(() => {
        if (!ref.current) return;
        ref.current.style.display = (status === 'ringing' || status === 'connecting' || status === 'in-call') ? 'grid' : 'none';
    }, [status]);

    return (  
        <div
            ref={ref}
            style={{
                position: 'fixed', right: 16, bottom: 16, zIndex: 6000,
                display: 'none', gap: 8, padding: 10, background: '#0f172a', color: '#fff',
                border: '1px solid #273347', borderRadius: 12, minWidth: 240
            }}
        >
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
                {incoming ? 'Входящий звонок' : (status === 'connecting' ? 'Подключение…' : 'Звонок')}
                {mode === 'video' ? ' (видео)' : ''}
            </div>

            {status === 'ringing' && incoming && (
                <div style={{ display: 'grid', gridAutoFlow: 'column', gap: 8 }}>
                    <button className="iconBtn" onClick={() => dispatch(acceptCall())}>✅ Принять</button>
                    <button className="iconBtn" onClick={() => dispatch(rejectCall())}>❌ Отклонить</button>
                </div>
            )}

            {(status === 'connecting' || status === 'in-call') && (
                <div style={{ display: 'grid', gridAutoFlow: 'column', gap: 8 }}>
                    <button className="iconBtn" onClick={() => dispatch(toggleMic())}>🎙️</button>
                    {mode === 'video' && <button className="iconBtn" onClick={() => dispatch(toggleCam())}>📷</button>}
                    <button className="iconBtn" onClick={() => dispatch(hangup('ended'))}>⛔ Завершить</button>
                </div>
            )}
        </div>
    );
}
